import React from 'react';

export default function Testimonials() {
  return (
    <>
      <section id="testimonials" className="text-gray-600 body-font">
        <div className="container px-5 pt-16 pb-28 mx-auto">
          <h1 className="text-4xl font-medium title-font text-gray-900 mb-12 text-center">
            Testimonials
          </h1>
          <div className="flex flex-wrap -m-4">
            <div className="p-6 md:w-1/2 w-full">
              <div className="h-full bg-litegreen p-8 rounded-lg shadow-2xl shadow-odgreen">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="litegreen"
                  className="block w-5 h-5 text-gray-400 mb-4 fill-odgreen"
                  viewBox="0 0 975.036 975.036"
                >
                  <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z"></path>
                </svg>
                <p className="leading-relaxed mb-6 lg:text-lg">
                  I loved working for Ares! They treat you like a person not
                  just an employee. They make sure you feel safe and prepared to
                  secure your post. If you're in security or looking to get into
                  it, Ares is a great company to go for!
                </p>
                <div className="inline-flex items-center">
                  <div className="w-12 h-12 inline-flex items-center justify-center rounded-full bg-odgreen text-white flex-shrink-0">
                    <svg
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      className="w-7 h-7"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                  <span className="flex-grow flex flex-col pl-4">
                    <span className="title-font font-medium text-lg text-gray-900">
                      Annette Jackson
                    </span>
                    <span className="text-odgreen text-sm">
                      Former Employee
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className="p-6 md:w-1/2 w-full">
              <div className="h-full bg-litegreen p-8 rounded-lg shadow-2xl shadow-odgreen">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="litegreen"
                  className="block w-5 h-5 text-gray-400 fill-odgreen mb-4"
                  viewBox="0 0 975.036 975.036"
                >
                  <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z"></path>
                </svg>
                <p className="leading-relaxed mb-6 text-black lg:text-lg">
                  Ares Security is the best security company in
                  Colorado! They are professional, reliable, and I would highly
                  recommend them to anyone looking for security services in this
                  industry.
                </p>
                <div className="inline-flex items-center">
                  <div className="w-12 h-12 inline-flex items-center justify-center rounded-full bg-odgreen text-white flex-shrink-0">
                    <svg
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      className="w-7 h-7"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                  <span className="flex-grow flex flex-col pl-4">
                    <span className="text-lg title-font font-medium text-gray-900">
                      Matt Schooley
                    </span>
                    <span className="text-odgreen text-sm">
                      General Manager
                    </span>
                    <span className="text-odgreen text-sm">
                      RiNo Supply Company - <em>Denver, Colorado.</em>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}